module.exports = __webpack_public_path__ + "static/media/anchor-logo.8cb0611d.svg";